import { STATIC_URL } from "./config";
import { FALSE, NULL, TRUE } from "constants/primitives";

export interface IIntegrationSettings {
  apiKey: string;
  dir: string | null;
  wildcardDir: string | null;
  dataLayer: string;
  stealthMode: boolean;
  forcedLang: string | null;
  silentMode: boolean;
  staticFilesUrl: string;
  debugMode: boolean;
}

export class IntegrationSettings implements IIntegrationSettings {
  public apiKey: IIntegrationSettings["apiKey"] = "";
  public dir: IIntegrationSettings["dir"] = NULL;
  public wildcardDir: IIntegrationSettings["wildcardDir"] = NULL;
  public dataLayer: IIntegrationSettings["dataLayer"] = "dataLayer";
  public stealthMode: IIntegrationSettings["stealthMode"] = FALSE;
  public forcedLang: IIntegrationSettings["forcedLang"] = NULL;
  public silentMode: IIntegrationSettings["silentMode"] = TRUE;
  public debugMode: IIntegrationSettings["debugMode"] = FALSE;
  public staticFilesUrl: IIntegrationSettings["staticFilesUrl"] =
    STATIC_URL || "";

  public set(
    key: keyof IIntegrationSettings,
    value: IIntegrationSettings[typeof key]
  ): void {
    (this[key] as IIntegrationSettings[typeof key]) = value;
  }
}

const integrationSettings = new IntegrationSettings();
export default integrationSettings;
